import { Controller } from "@hotwired/stimulus"

// The +N chip on a link row (#3531): every tag is in the DOM and the ones
// past the cap are folded by CSS, so opening is one class flip on the row's
// tag list. The button reports the state through aria-expanded.
export default class extends Controller {
  toggle(event) {
    const open = this.element.classList.toggle("tag-fold--open")
    event.currentTarget.setAttribute("aria-expanded", open)
  }
}
